import React, { useEffect, useState } from 'react';

// Live countdown to the given ISO target date.
const pad = (n) => String(n).padStart(2, '0');

const Countdown = ({ target }) => {
    const [now, setNow] = useState(() => new Date());

    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), 1000);
        return () => clearInterval(id);
    }, []);

    const targetDate = new Date(target);
    const diff = Math.max(0, targetDate - now);

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    const cells = [
        { k: days, l: 'días' },
        { k: pad(hours), l: 'hs' },
        { k: pad(minutes), l: 'min' },
        { k: pad(seconds), l: 'seg' },
    ];

    return (
        <div className="inline-flex flex-col">
            <div className="overline text-white/60 mb-2">Cuenta regresiva · FITUR Madrid</div>
            <div className="flex items-baseline gap-3 md:gap-4">
                {cells.map((c, i) => (
                    <React.Fragment key={i}>
                        <div className="flex flex-col items-center">
                            <span className="num-display text-white text-2xl sm:text-3xl md:text-5xl leading-none">
                                {c.k}
                            </span>
                            <span className="text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-white/50 mt-1">
                                {c.l}
                            </span>
                        </div>
                        {i < cells.length - 1 && (
                            <span className="num-display text-white/30 text-2xl sm:text-3xl md:text-5xl leading-none pb-2 sm:pb-3">:</span>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default Countdown;
